import Connection, {PEER_APP} from './Connection.js'

function genCode(length=5) {
  let result           = '';
  let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let charactersLength = characters.length;
  for(let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
    charactersLength));
  }
  return result;
}

class Member extends Connection {
  constructor(hostCode, name, options={}) {
    let code = genCode();
    super(hostCode+'-'+code, name, options);

    this.hostCode = hostCode;

    this.peer.on('open', () => {
      const conn = this.conn = this.peer.connect(PEER_APP+'-'+hostCode, {
        // reliable: true
      });

      conn.on('open', () => {
        // console.log('OPEN !')
        this.ping_interval = setInterval(() => {
          conn.send({
            type: 'ping',
          });
        }, 30_000);

        this.sync();

        this.options?.onReady();
      });

      conn.on('data', data => {
        // console.log(data)

        if(data.type === 'sync') {
          this.setState(data.state);
        }
        // else if(data.type === 'winner') {
        //   options.onWinner(data.winner);
        // }
      });

      conn.on('error', err => {
        this.conn = null;

        console.log('ERROR')
        console.log(err)

        options.onError?.(err);
      });

      conn.on('close', () => {
        // console.log('CLOSE !')
        this.conn = null;

        // options.onClose?.();
        this.close();
      });
    });

    this.peer.on('close', () => {
      clearInterval(this.ping_interval);
    });
  }

  setMesFilms(mesFilms) {
    if(this.state.state !== 'open')
      return;

    super.setMesFilms(mesFilms);

    this.sync();
  }

  sync() {
    this.conn?.send({
      type: 'sync',
      data: {
        name: this.name,
        films: this.mesFilms,
      },
    });
  }

  submit() {
    // if(this.state.state !== 'open')
    //   return;
    // console.log('submit !')

    this.conn?.send({
      type: 'submit',
    });
  }

  vote(film_name) {
    if(this.state.state !== 'vote')
      return;

    this.conn?.send({
      type: 'vote',
      film: film_name,
    });
  }
}

export default Member